export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || "test";
export const NEW_DOMAIN = process.env.REACT_APP_NEW_DOMAIN || "no";
